import * as authTypes from "../types/auth";

const initStore = {
  loginObj: null,
};

export default (state = initStore, action) => {
  // console.log("action: ", action);
  switch (action.type) {
    case authTypes.SAVE_LOGIN_OBJ:
      return { ...state, loginObj: action.payload };
    case authTypes.USER_LOGGED_OUT:
      return { ...state, loginObj: null };
    default:
      return state;
  }
};
